import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { FormModal } from 'transfix-ui/components/Modals'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Box } from 'transfix-ui/core'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import { createShipperRate, updateShipperRate } from 'apps/rms/utils/actions/shipperRates'

interface IShipperRateConfirmationModalProps {
  openConfirmation: boolean
  message: string
  isUpdate: boolean
  shipperRate: RecursivePartial<IShipperRate>
  onClose: () => void
}

export const ShipperRateConfirmationModal = ({
  isUpdate,
  message,
  onClose,
  openConfirmation,
  shipperRate,
}: IShipperRateConfirmationModalProps) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const submitRequest = () => {
    setIsLoading(true)
    if (isUpdate) {
      dispatch(updateShipperRate(shipperRate))
    } else {
      dispatch(createShipperRate(shipperRate))
    }
    onClose()
  }

  return (
    <FormModal
      size={4}
      onClose={onClose}
      open={openConfirmation}
      title='Are you sure?'
      className='ph0'
      actions={[
        {
          type: 'dismiss',
          label: 'Cancel',
          dataTest: 'cancel-button',
          action: onClose,
          disabled: isLoading,
        },
        {
          label: 'Submit',
          type: 'confirm',
          dataTest: 'delete-confirm-button',
          action: submitRequest,
          disabled: isLoading,
        },
      ]}>
      <span>{message}</span>
      {isLoading && (
        <Box mb={3} mt={3}>
          <Spinner position='relative' />
        </Box>
      )}
    </FormModal>
  )
}
